// extracted by mini-css-extract-plugin
export default {"Box":"NewEvent_Box__9JDLi","EventBox":"NewEvent_EventBox__AZyw2","BoxInnerHeader":"NewEvent_BoxInnerHeader__p0vmZ","BoxHeader":"NewEvent_BoxHeader__YADlc"};